/** axios封装
 *** 请求拦截、相应拦截、错误统一处理
 **/
import axios from "axios"; // 引入axios
import qs from "qs"; // 引入qs模块，用来序列化post类型的数据
import { Toast } from "vant"; // 引入vant的toast提示框组件
import router from "../router";
import appLoading from "@/components/axiosLoading/index";
import { getStore, removeStore } from "@/store/storage";
import common from "./constants";

let serverTestUrl = common.interfacePath.serverTestUrl; //天燃气Buyer
// 环境的切换
if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = serverTestUrl;
} else if (process.env.NODE_ENV === "debug") {
  axios.defaults.baseURL = serverTestUrl;
} else if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = serverTestUrl;
}

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    loading("loading", "加载中...", 0);
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = cookies.get("token");
    // token && (config.headers.Authorization = token);

    // const token = store.state.token;
    const token = getStore("token");
    token && (config.headers.Authorization = token);

    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  // 正常响应
  (response) => {
    Toast.clear();
    if (response.status === 200) {
      if (response.data.returnCode == "LOGIN_1_1001") {
        //登录超时，token过期
        loading("fail", "登录过期", 1500);
        removeStore("token");
        setTimeout(() => {
          console.log(router.currentRoute.fullPath);
          localStorage.removeItem("userInfo");
          localStorage.removeItem("token");
          // localStorage.clear();
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
        }, 1000);
      } else {
        return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    appLoading.close();
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          loading("fail", "请求错误", 1500);
          break;
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          loading("fail", "未授权，请登录", 1500);
          localStorage.removeItem("userInfo");
          localStorage.removeItem("token");
          // localStorage.clear();
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath },
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          loading("fail", "登录过期", 1500);
          // 清除token
          removeStore("token");
          setTimeout(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("token");
            // localStorage.clear();
            console.log(router.currentRoute.fullPath);
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          loading("fail", "请求地址出错", 1500);
          break;
        case 408:
          loading("fail", "请求超时", 1500);
          break;
        case 500:
          loading("fail", "服务器错误", 1500);
          break;
        case 501:
          loading("fail", "服务未实现", 1500);
          break;
        case 502:
          loading("fail", "网关错误", 1500);
          break;
        case 503:
          loading("fail", "服务不可用", 1500);
          break;
        case 504:
          loading("fail", "网关超时", 1500);
          break;
        case 505:
          loading("fail", "HTTP版本不受支持", 1500);
          break;
        default:
          loading("fail", error.response.data.error, 1500);
      }
      return Promise.reject(error.response);
    }
  }
);

// 封装页面加载时loading动画
function loading(type, message, duration) {
  Toast({
    type: type,
    message: message,
    duration: duration,
    forbidClick: true,
    loadingType: "spinner",
  });
}

/**
 * 定义名为fetch的请求方法，包括get、post以及特殊的请求格式
 * @param {Object} opts [http请求配置]
 * @param {Object} params [请求时携带的参数]
 *
 * opts.method为get时: params不需要序列化
 * opts.method为post且opt.paramsType为nonserialize时: params不需要序列化
 * opts.method为post且opt.paramsType为serialize时: params需要序列化
 */
export function fetch(opts, params) {
  // 定义请求默认配置对象
  let httpDefaultOpts = {
    method: opts.method,
    url: opts.url,
    data: params,
    async: false,
    showLoading: opts.showLoading,
  };
  // 根据请求方法get/post判断是否需要序列化params
  if (opts.method === "get") {
    httpDefaultOpts.data = params;
  } else {
    if (opts.paramsType === "serialize") {
      httpDefaultOpts.data = qs.stringify(params);
    } else {
      httpDefaultOpts.data = params;
    }
  }
  // 返回Promise对象
  return new Promise((resolve, reject) => {
    axios(httpDefaultOpts)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, typeof data == 'object' ? JSON.stringify(params) : params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
